import _toConsumableArray from '@babel/runtime/helpers/toConsumableArray';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { mapBackgroundImageAndGradient } from '../../util/background.js';
import { cx, toCx, _, toCxn } from '../../util/classname.js';
import { isEmptyObject } from '../../util/isEmptyObject.js';
import { alignContentMap, alignItemsMap, alignSelfMap, borderStyleMap, boxSizingMap, cursorMap, displayMap, flexDirectionMap, flexMap, flexGrowMap, flexShrinkMap, flexWrapMap, floatMap, gridAutoColumnsMap, gridAutoFlowMap, gridAutoRowsMap, justifyContentMap, listStyleMap, outlineStyleMap, overflowMap, overflowScrollingMap, overflowXMap, overflowYMap, pointerEventsMap, positionMap, scrollSnapAlignMap, scrollSnapStopMap, scrollSnapTypeMap, scrollSnapMap, textAlignMap, textDecorationMap, textOverflowMap, touchActionMap, verticalAlignMap, userSelectMap, visibilityMap, whiteSpaceMap, wordBreakMap } from '../../util/mappers.mappings.js';
import { getDefaultBackground, mapBackground, mapBorderColor, mapTextColor, mapFloat, mapGradient } from '../../util/mappers.util.js';
import { scopeClassName } from '../../util/scopeClassName.js';
import { selectToken } from '../../util/tokenSelector.js';
import toRgbColor from '../../util/toRgbColor.js';
import { mapUnboundedProps } from '../../util/unboundedProps.js';
import { Direction } from '../../contexts/session/Locale.js';
import { MediaQueryToken as Token } from '../../contexts/system/MediaQuery.js';

var _excluded = ["adsClass", "alignContent", "alignItems", "alignSelf", "as", "aspectRatio", "backgroundColor", "backgroundImage", "backgroundPosition", "backgroundRepeat", "backgroundSize", "borderColor", "borderRadius", "borderStyle", "borderWidth", "bottom", "boxShadow", "boxSizing", "children", "clipPath", "columnGap", "cursor", "DEPRECATED_gap", "display", "empty", "end", "filter", "flex", "flexBasis", "flexDirection", "flexGrow", "flexShrink", "flexWrap", "float", "gap", "gridAutoColumns", "gridAutoFlow", "gridAutoRows", "height", "hideScrollbar", "interactive", "interactiveChild", "interactiveWithin", "justifyContent", "left", "listStyle", "m", "maskImage", "maxHeight", "maxWidth", "mb", "me", "minHeight", "minWidth", "ms", "mt", "mx", "my", "opacity", "order", "outlineColor", "outlineStyle", "overflow", "overflowScrolling", "overflowX", "overflowY", "p", "pb", "pe", "pointerEvents", "position", "ps", "pt", "px", "py", "right", "rowGap", "safeArea", "scrollSnapAlign", "scrollSnapStop", "scrollSnapType", "start", "style", "textAlign", "textColor", "textDecoration", "textOverflow", "top", "touchAction", "transform", "transition", "userSelect", "verticalAlign", "visibility", "whiteSpace", "width", "wordBreak", "zIndex", "type", "value", "className", "qM", "qL", "qXl"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var corners = ['tl', 'tr', 'br', 'bl']; // ADSWEB-1459 test
var sides = ['t', 'r', 'b', 'l'];
var classNameComponent = scopeClassName('box');
var emptyObject = {};
var mapBorder = function mapBorder(borderWidth, isButton) {
  return isButton && !borderWidth ? '0' : borderWidth;
};
var mapCursor = function mapCursor(cursor, isButton) {
  return isButton && !cursor ? 'pointer' : cursor;
};
var mapFlexBasis = function mapFlexBasis(flexBasis) {
  return (flexBasis || flexBasis === 0) && {
    flexBasis: flexBasis
  };
};
var getRgbFromInteractive = function getRgbFromInteractive(theme, interactive) {
  var hex = selectToken(theme.text, interactive);
  return hex ? toRgbColor(hex) : undefined;
};

// How to not hard code like this?
var mapInteractiveStyle = function mapInteractiveStyle(theme, interactive) {
  if (interactive) {
    var interactiveRgb = getRgbFromInteractive(theme, interactive);
    return {
      '--interactive-color': "".concat(interactiveRgb === null || interactiveRgb === void 0 ? void 0 : interactiveRgb.red, ", ").concat(interactiveRgb === null || interactiveRgb === void 0 ? void 0 : interactiveRgb.green, ", ").concat(interactiveRgb === null || interactiveRgb === void 0 ? void 0 : interactiveRgb.blue),
      '--interactive-color-primary': 'var(--ads-colors-primary-base-intent)',
      '--color-neutral-4': 'var(--ads-colors-generic-base-inverted)'
    };
  }
  return undefined;
};
var mapInteractiveWithinStyle = function mapInteractiveWithinStyle(theme, interactiveWithin) {
  if (interactiveWithin) {
    var interactiveWithinRgb = getRgbFromInteractive(theme, interactiveWithin);
    return {
      '--interactive-within-color': "".concat(interactiveWithinRgb === null || interactiveWithinRgb === void 0 ? void 0 : interactiveWithinRgb.red, ", ").concat(interactiveWithinRgb === null || interactiveWithinRgb === void 0 ? void 0 : interactiveWithinRgb.green, ", ").concat(interactiveWithinRgb === null || interactiveWithinRgb === void 0 ? void 0 : interactiveWithinRgb.blue)
    };
  }
  return undefined;
};
var mapSafeArea = function mapSafeArea(safeArea) {
  return [safeArea.top && 'pt-safe', safeArea.bottom && 'pb-safe', safeArea.left && 'pl-safe', safeArea.right && 'pr-safe'].filter(Boolean);
};
var mapLeftRight = function mapLeftRight(direction, input) {
  var isLtr = direction === Direction.LTR;
  var leftValue = input.left;
  var rightValue = input.right;
  if (leftValue === undefined) {
    leftValue = isLtr ? input.start : input.end;
  }
  if (rightValue === undefined) {
    rightValue = isLtr ? input.end : input.start;
  }
  return {
    left: leftValue,
    right: rightValue
  };
};
var mapBoxAttributes = function mapBoxAttributes(props, attributes) {
  var as = props.as,
    type = props.type,
    value = props.value;
  var isButton = as === 'button';
  var isInput = as && ['input', 'textarea', 'select'].includes(as);
  var inputType = isInput ? type : undefined;
  var buttonType = isButton ? type || 'button' : undefined;
  var inputValue = isInput || isButton ? value : undefined;
  return _objectSpread(_objectSpread({}, attributes), {}, {
    type: buttonType || inputType,
    value: inputValue
  });
};
var mapProps = function mapProps(props, direction, theme, screen, intent) {
  if (isEmptyObject(props)) {
    return {};
  }
  var adsClass = props.adsClass,
    alignContent = props.alignContent,
    alignItems = props.alignItems,
    alignSelf = props.alignSelf,
    as = props.as,
    aspectRatio = props.aspectRatio,
    backgroundColor = props.backgroundColor,
    backgroundImage = props.backgroundImage,
    backgroundPosition = props.backgroundPosition,
    backgroundRepeat = props.backgroundRepeat,
    backgroundSize = props.backgroundSize,
    borderColor = props.borderColor,
    borderRadius = props.borderRadius,
    borderStyle = props.borderStyle,
    borderWidth = props.borderWidth,
    bottom = props.bottom,
    boxShadow = props.boxShadow,
    boxSizing = props.boxSizing,
    children = props.children,
    clipPath = props.clipPath,
    columnGap = props.columnGap,
    cursor = props.cursor,
    DEPRECATED_gap = props.DEPRECATED_gap,
    display = props.display,
    empty = props.empty,
    end = props.end,
    filter = props.filter,
    flex = props.flex,
    flexBasis = props.flexBasis,
    flexDirection = props.flexDirection,
    flexGrow = props.flexGrow,
    flexShrink = props.flexShrink,
    flexWrap = props.flexWrap,
    float = props.float,
    gap = props.gap,
    gridAutoColumns = props.gridAutoColumns,
    gridAutoFlow = props.gridAutoFlow,
    gridAutoRows = props.gridAutoRows,
    height = props.height,
    hideScrollbar = props.hideScrollbar,
    interactive = props.interactive,
    interactiveChild = props.interactiveChild,
    interactiveWithin = props.interactiveWithin,
    justifyContent = props.justifyContent,
    left = props.left,
    listStyle = props.listStyle,
    m = props.m,
    maskImage = props.maskImage,
    maxHeight = props.maxHeight,
    maxWidth = props.maxWidth,
    mb = props.mb,
    me = props.me,
    minHeight = props.minHeight,
    minWidth = props.minWidth,
    ms = props.ms,
    mt = props.mt,
    mx = props.mx,
    my = props.my,
    opacity = props.opacity,
    order = props.order,
    outlineColor = props.outlineColor,
    outlineStyle = props.outlineStyle,
    overflow = props.overflow,
    overflowScrolling = props.overflowScrolling,
    overflowX = props.overflowX,
    overflowY = props.overflowY,
    p = props.p,
    pb = props.pb,
    pe = props.pe,
    pointerEvents = props.pointerEvents,
    position = props.position,
    ps = props.ps,
    pt = props.pt,
    px = props.px,
    py = props.py,
    right = props.right,
    rowGap = props.rowGap,
    safeArea = props.safeArea,
    scrollSnapAlign = props.scrollSnapAlign,
    scrollSnapStop = props.scrollSnapStop,
    scrollSnapType = props.scrollSnapType,
    start = props.start,
    defaultStyle = props.style,
    textAlign = props.textAlign,
    textColor = props.textColor,
    textDecoration = props.textDecoration,
    textOverflow = props.textOverflow,
    top = props.top,
    touchAction = props.touchAction,
    transform = props.transform,
    transition = props.transition,
    userSelect = props.userSelect,
    verticalAlign = props.verticalAlign,
    visibility = props.visibility,
    whiteSpace = props.whiteSpace,
    width = props.width,
    wordBreak = props.wordBreak,
    zIndex = props.zIndex,
    _type = props.type,
    _value = props.value,
    _props$className = props.className,
    classNameDeprecated = _props$className === void 0 ? '' : _props$className,
    _props$qM = props.qM,
    qM = _props$qM === void 0 ? emptyObject : _props$qM,
    _props$qL = props.qL,
    qL = _props$qL === void 0 ? emptyObject : _props$qL,
    _props$qXl = props.qXl,
    qXl = _props$qXl === void 0 ? emptyObject : _props$qXl,
    attributes = _objectWithoutProperties(props, _excluded);
  var isLtr = direction === Direction.LTR;
  var isButton = as === 'button';
  var _mapUnboundedProps = mapUnboundedProps({
      height: height,
      minHeight: minHeight,
      maxHeight: maxHeight,
      width: width,
      minWidth: minWidth,
      maxWidth: maxWidth,
      order: order
    }),
    classNameBounded = _mapUnboundedProps.className,
    styleUnbounded = _mapUnboundedProps.style;
  var bgColor = getDefaultBackground(backgroundColor, isButton);
  var className = cx([mapBackground(bgColor, {
    intent: intent
  }), toCx('bg', backgroundRepeat), toCx('bg', backgroundSize), mapBorderColor(borderColor, {
    intent: intent
  }), mapTextColor(textColor, 'fill', {
    intent: intent
  }), toCx('outline', outlineColor), toCx('shadow', boxShadow), mapTextColor(textColor, 'text', {
    intent: intent
  }), toCx('filter', filter)].concat(_toConsumableArray(classNameBounded), [
  // TODO: ADSWEB-1279 no spread/concat
  alignContentMap[alignContent], alignItemsMap[alignItems], alignSelfMap[alignSelf], borderStyleMap[borderStyle], boxSizingMap[boxSizing], cursorMap[mapCursor(cursor, isButton)], displayMap[display], flexDirectionMap[flexDirection], flexMap[flex], flexGrowMap[flexGrow], flexShrinkMap[flexShrink], flexWrapMap[flexWrap], floatMap[mapFloat(float, direction)], gridAutoColumnsMap[gridAutoColumns], gridAutoFlowMap[gridAutoFlow], gridAutoRowsMap[gridAutoRows], justifyContentMap[justifyContent], listStyleMap[listStyle], outlineStyleMap[outlineStyle], overflowMap[overflow], overflowScrollingMap[overflowScrolling], overflowXMap[overflowX], overflowYMap[overflowY], pointerEventsMap[pointerEvents], positionMap[position], scrollSnapAlignMap[scrollSnapAlign], scrollSnapStopMap[scrollSnapStop], scrollSnapTypeMap[scrollSnapType], scrollSnapMap[scrollSnapType], textAlignMap[textAlign], textDecorationMap[textDecoration], textOverflowMap[textOverflow], touchActionMap[touchAction], verticalAlignMap[verticalAlign], userSelectMap[userSelect], visibilityMap[visibility], whiteSpaceMap[whiteSpace], wordBreakMap[wordBreak], toCx('m', m), toCx('mx', mx), toCx('my', my), toCx('mb', mb), toCx('mt', mt), toCx(isLtr ? 'mr' : 'ml', me), toCx(isLtr ? 'ml' : 'mr', ms), toCx('p', p), toCx('px', px), toCx('py', py), toCx('pb', pb), toCx('pt', pt), toCx(isLtr ? 'pr' : 'pl', pe), toCx(isLtr ? 'pl' : 'pr', ps), toCx('gap', gap), toCx('gap-y', rowGap), toCx('gap-x', columnGap), empty ? 'empty:hidden' : undefined], _toConsumableArray(mapSafeArea(safeArea !== null && safeArea !== void 0 ? safeArea : {}))), screen) + _ + toCxn('rounded', borderRadius, corners, false, screen) + _ + toCxn('border', mapBorder(borderWidth, isButton), sides, undefined, screen);
  if (screen) {
    return {
      className: className
    };
  }
  className = cx([classNameComponent, classNameDeprecated, className], false) + _ + cx([interactive && 'interactive', interactiveWithin ? 'interactive-within' : undefined, interactiveChild ? 'interactive-child' : undefined, hideScrollbar ? 'no-scrollbar' : undefined]);
  if (adsClass) {
    className = className + _ + cx(adsClass, undefined);
  }
  var _mapProps = mapProps(qM, direction, theme, Token.Medium),
    classNameM = _mapProps.className;
  var _mapProps2 = mapProps(qL, direction, theme, Token.Large),
    classNameL = _mapProps2.className;
  var _mapProps3 = mapProps(qXl, direction, theme, Token.ExtraLarge),
    classNameXl = _mapProps3.className;
  className = cx([className, classNameM, classNameL, classNameXl], false);
  var maskGradient = mapGradient(maskImage, direction, undefined, intent);
  var style = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    transition: transition,
    transform: transform
  }, mapFlexBasis(flexBasis)), {}, {
    opacity: opacity,
    aspectRatio: aspectRatio,
    top: top,
    bottom: bottom,
    // reason to put backgroundPosition and backgroundImage in the inline style here because they are both supported dynamic values
    // image supported dynamic url ex. url('image-url') and position supported dynamic number values ex. 20% 20%, 20px 20px, etc.
    backgroundPosition: backgroundPosition
  }, mapLeftRight(direction, {
    left: left,
    right: right,
    start: start,
    end: end
  })), {}, {
    zIndex: zIndex,
    gap: DEPRECATED_gap,
    WebkitMask: maskGradient,
    mask: maskGradient,
    clipPath: clipPath
  }, mapBackgroundImageAndGradient(direction, undefined, backgroundColor, backgroundImage)), styleUnbounded), mapInteractiveStyle(theme, interactive)), mapInteractiveWithinStyle(theme, interactiveWithin)), defaultStyle);
  return {
    as: as,
    attributes: mapBoxAttributes(props, attributes),
    children: children,
    className: className,
    style: style
  };
};

export { mapBackground, mapBorder, mapBoxAttributes, mapCursor, mapFlexBasis, mapFloat, mapInteractiveStyle, mapLeftRight, mapProps, mapSafeArea };
//# sourceMappingURL=BoxExperimentalCss.mappers.js.map
